import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CustomBox } from '../../components/Tutor/style';
import Text from '../Text';
import InputLegend from '../InputLegend';
import CustomInput from '../CustomInput';
import CTA from '../CTA';
import ActivityBox from '../ActivityBox';
import {
  ADD_ACTIVITY,
  DEL_SECTION,
  UPDATE_SECTION,
} from '../../../app/redux/actions/tutors';
import { withMediaQueries } from '../../../app/hoc/withMediaQueries';

const SectionBox = ({
  mediaIsPhone,
  index,
  delSection,
  updateSection,
  sections,
  sectionKey,
  addActivity,
}) => {
  const section = sections[sectionKey] || {};

  useEffect(() => {
    if (Object.keys(section?.activities || {})?.length <= 0) {
      addActivity(sectionKey);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionKey]);

  const sortActivities = (a, b) => {
    if (
      !(section.activities[a]?.order >= 0 || section.activities[b]?.order >= 0)
    ) {
      return 0;
    }
    return section.activities[a].order - section.activities[b].order;
  };

  return (
    <CustomBox className="mb-4">
      <div className="d-flex sb">
        <Text type="h2" mb={24}>
          Sezione {index}
        </Text>
        {index > 1 && (
          <CTA
            type="tertiary"
            btnText="Elimina"
            icon="trash-01"
            onClick={() => delSection(sectionKey)}
          />
        )}
      </div>
      <InputLegend
        label="Titolo sezione"
        tooltipKey="course_section_title"
        type="secondary"
        htmlFor="course-section-title"
      />
      <CustomInput
        size={mediaIsPhone ? 'full' : 'm'}
        placeholder="Inserisci"
        onChange={(newValue) => updateSection(sectionKey, 'title', newValue)}
        value={section?.title}
        id="course-section-title"
      />
      {Object.keys(section.activities || {})
        .sort(sortActivities)
        .map((k, i) => (
          <ActivityBox
            key={`activity-${sectionKey}-${i}`}
            index={i + 1}
            sectionKey={sectionKey}
            activityKey={k}
          />
        ))}
      <CTA
        type="tertiary"
        btnText="Aggiungi altra attività"
        icon="plus"
        onClick={() => addActivity(sectionKey)}
      />
    </CustomBox>
  );
};

SectionBox.propTypes = {
  mediaIsPhone: PropTypes.bool,
  index: PropTypes.number,
  sections: PropTypes.object,
  sectionKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  updateSection: PropTypes.func,
  delSection: PropTypes.func,
  addActivity: PropTypes.func,
};

export default connect(
  (state) => {
    const { sections } = state.tutors.activities;
    return { sections };
  },
  (dispatch) => ({
    delSection: (id) => dispatch({ type: DEL_SECTION, id }),
    updateSection: (id, field, value) =>
      dispatch({ type: UPDATE_SECTION, id, field, value }),
    addActivity: (secId) => dispatch({ type: ADD_ACTIVITY, secId }),
  })
)(withMediaQueries(SectionBox));
